import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  saveLoading: false,
  factorName: null,
  factorNameError: "",
  formError: "",
};

export default function FactorNameReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_FACTOR_NAME:
      return { ...state, loading: action.payload };
    case actions.SAVE_LOADING_FACTOR_NAME:
      return { ...state, saveLoading: action.payload };
    case actions.GET_FACTOR_NAME:
      return { ...state,factorName: action.payload };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FACTOR_FAIL:
      return { ...state, factorNameError: action.payload };
    default:
      return state;
  }
}
